import React from "react";
import { HREF } from "../../db";

function AboutUs() {
  return (
    <React.Fragment>
      <div className="local fl">
        <h3>About Us</h3>
        <div className="dqwz fr">
          Current Position:
          <a href={HREF.INDEX}>Home</a>
          &gt;
          <a href={HREF.ABOUTUS}>About Us</a>
        </div>
      </div>
      <div className="content fl">
        <div className="content-con fl">
          <div id="vsb_content">
            <h1
              style={{
                margin: "15px auto 50px",
                lineHeight: "30px",
                textAlign: "center",
              }}
            >
              About Us
            </h1>
            <div
              style={{ textIndent: "2em", fontFamily: "微软雅黑, sans-serif" }}
            >
              <p>
                <strong>
                  Welcome to Group of City Science and Social Computing based in
                  Zhejiang University of Technology, China.
                </strong>
              </p>
              <p>
                Based on the acquisition, integration, analysis of big and
                heterogeneous data generated by a diversity of sources in urban
                spaces, we solve the problems faced by cities through computer
                science.
              </p>
              <p>
                We aim at harmony, and not at uniformity; respect different
                personalities; advocate diligence and cooperation; embrace the
                change and the differences; admit the sweat and personal
                results.
              </p>
              <p>
                We have a series of innovative research results, top journals
                and conference papers, a variety of awards.
              </p>
              <p>
                We have a comfortable study and work environment, sufficient
                research funds, unity and friendship of the laboratory
                atmosphere.
              </p>
              <p>
                <strong>Full name of the Lab:</strong>
                City Science & Social Computing @ Zhejiang University of
                Technology, China
              </p>
              <p>
                <strong>Address:</strong>
                B311, Computer Building, No. 288 Liuhe Road, Xihu District,
                Hangzhou
              </p>
              <p>
                <strong>Contact Person:</strong>
                <a href="mailto:xjkong@ieee.org">xjkong@ieee.org</a>
              </p>
              <p>
                <strong>URL(website):</strong>
                <a href="http://www.cssclab.cn">http://www.cssclab.cn</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export { AboutUs };
